import React, { useState } from "react";
import { Form, Field } from "react-final-form";
import Input from "../../components/atoms/Input/input";
import {
  composeValidators,
  requiredFieldValidator,
  mustBeANumber
} from "../../common/Utility/validator";
import { connect } from "react-redux";

import { channelAll } from "./channelTypes";
import Modal from "../../components/atoms/Modal";
import Button from "../../components/atoms/Button/Button";
import { getEncryptedMessage } from "../../common/utility";
import { userLogin } from "../../api/SignupAPI";
import styles from "./twoFactorAuth.module.scss";
import Heading from "../../components/atoms/Heading/Heading";
const TwoFactorAuth = ({ handleClose, credentialsVerified, emailId, screenSizeReducer }) => {
  const [modal, setModal] = useState(true);
  const { isMobile, isTablet } = screenSizeReducer;
  let modalWidth = (isMobile || isTablet) ? "90vw" : "55vw";
  const verifyLogin = async (values) => {
    try {
      let headers = { "Content-Type": "application/x-www-form-urlencoded" };
      let bodyParams =
        "emailId=" +
        encodeURIComponent(emailId) +
        "&password=" +
        encodeURIComponent(getEncryptedMessage(values.password)) +
        "&otp=" +
        values.verificationCode +
        "&channel=" +
        channelAll +
        "&grantType=PASSWORD";
      const loginResp = await userLogin(headers, bodyParams);
      if (loginResp) {
        credentialsVerified(loginResp);
      }
    } catch (e) {
      console.log(e, "err");
      handleClose();
      // return handleLoginError(e);
    }
  };
  return (
    <Modal
      open={modal}
      minheight="35vh"
      width={modalWidth}
      className={styles["tfa-modal-content"]}
      handleClose={(event, reason) => {
        if (reason === "backdropClick") {
          return;
        }
        setModal(false);
        handleClose(false);
      }}
      titleName={`Please Verify Your Credentials`}
    >
      <div className={styles.card}>
        <Heading text="Please verify Your Credentials" variant="h3" />
        <Form
          onSubmit={verifyLogin}
          render={({
            handleSubmit,
            form,
            submitError,
            hasValidationErrors,
            submitting,
            dirtySinceLastSubmit,
            ...rest
          }) => (
            <form
              onSubmit={(values) => {
                let promise = handleSubmit(values);
                promise &&
                  promise.then((result) => {
                    if (!result) {
                      form.restart(); // Clear All Form Data After Success
                    }
                  });
              }}
            >
              <Field
                required={true}
                component={Input}
                label="Password"
                type="password"
                name="password"
                key="password"
                autoFocus={true}
                validate={composeValidators([requiredFieldValidator])}
              />
              <Field
                required={true}
                label="OTP Received On Email/Mobile"
                component={Input}
                name="verificationCode"
                key="verificationCode"
                validate={composeValidators([
                  requiredFieldValidator,
                  mustBeANumber("Verification Code")
                ])}
              />
              {!dirtySinceLastSubmit && submitError && (
                <p className="input-error-msg sign-in-error">{submitError}</p>
              )}
              <Button
                btnText="Sign In"
                type="submit"
                variant="primary-fullwidth"
                disabled={hasValidationErrors}
              />
            </form>
          )}
        />
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  screenSizeReducer: state.screenSizeReducer
});

export default connect(mapStateToProps)(TwoFactorAuth);
